import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import API from '../../api';
import { SnackbarContext } from '../../contexts';
import Handler from '../../Handler';

export const useProject = () => {
  const { slug } = useParams();
  const { updateSnackbar } = useContext(SnackbarContext);
  const history = useHistory();
  const { t } = useTranslation();

  const [project, setProject] = useState(null);

  const getProject = () => {
    if (slug) {
      API.Project.GetWriting(slug).then((res) => {
        setProject(res.data);
      });
    }
  };

  const genPayload = (data) => {
    return {
      address: data.address,
      site: data.site,
      fax: data.fax,
      name: data.name,
      phone: data.phone,
      department: data.department,
      email: data.email,
      isCheckedArea: data.isCheckedArea || false,
      isExported: data.isExported || false,
      exportedTitle: data.exportedTitle,
      exportedOrgan: data.exportedOrgan,
      exportedDate: data.exportedDate,
      title: data.title,
      methodologySeq: Number(data.methodologySeq),
      purpose: data.purpose,
      content: data.content,
      location: typeof data.location === 'string' ? data.location : JSON.stringify(Handler.jsonParser(data.location)),
      reductionStartDate: data.reductionStartDate,
      reductionEndDate: data.reductionEndDate,
      isDomestic: data.isDomestic,
      workplaceImages: data.workplaceImages?.length > 0 ? data.workplaceImages : [],

      reductionBase: data.reductionBase || 0,
      reductionBusiness: data.reductionBusiness || 0,
      reductionLeak: data.reductionLeak || 0,
      reduction: data.reduction || 0,
      monitoringType: data.monitoringType || 'Document',
      monitoringPlan: data.monitoringPlan,
      beforeImages: data.beforeImages?.length > 0 ? data.beforeImages : [],
      afterImages: data.afterImages?.length > 0 ? data.afterImages : [],
      proofFile: data.proofFile,
      evidence: data.evidence?.length > 0 ? data?.evidence : [],
    };
  };

  const postProject = (data) => {
    const payload = genPayload(data);

    API.Project.PostNew(payload)
      .then((res) => {
        const result = res.data;
        history.replace(`/project/writing/${result.seq}`);
        updateSnackbar({
          type: 'success',
          open: true,
          message: t('SAVED'),
        });
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data?.message || '저장 중 오류가 발생했습니다.',
        });
        return false;
      });
  };

  const putProject = (data) => {
    const payload = genPayload(data);
    API.Project.PutWriting(slug, payload)
      .then((res) => {
        updateSnackbar({
          type: 'success',
          open: true,
          message: t('SAVED'),
        });
      })
      .catch((err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
        return false;
      });
  };

  return {
    project,
    getProject,
    postProject,
    putProject,
  };
};
